import { render, staticRenderFns } from "./RealTimeView.vue?vue&type=template&id=70de601e&scoped=true"
import script from "./RealTimeView.vue?vue&type=script&lang=js"
export * from "./RealTimeView.vue?vue&type=script&lang=js"
import style0 from "./RealTimeView.vue?vue&type=style&index=0&id=70de601e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70de601e",
  null
  
)

export default component.exports